/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box } from '@mui/material';
import { useConfirm } from 'material-ui-confirm';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IS_SA, WEBSITE_URL } from '../../../../config/appConfig';
import { AppRoutes } from '../../../../constants/appRoutes';
import { BecomeProStatuses } from '../../../../constants/becomeProStatus';
import { BucketTypes } from '../../../../constants/bucketTypes';
import { OTPTypes } from '../../../../constants/otpTypes';
import { currencyFormatterHelper } from '../../../../helpers/currencyFormatterHelper';
import { DateHelper } from '../../../../helpers/dateHelper';
import { buildLocalizeRoute } from '../../../../helpers/languageHelper';
import { getUser } from '../../../../services/authService';
import { BecomeProService } from '../../../../services/becomeProService';
import { LanguageService } from '../../../../services/languageService';
import { SystemSettingsService } from '../../../../services/systemSettingsService';
import { Section } from '../../../../shared/components/common/section';
import { CustomTooltip } from '../../../../shared/components/common/tooltip';
import { ButtonWrapper } from '../../../../shared/components/formUtilities/useButton';
import { TextWrapper } from '../../../../shared/components/formUtilities/useTextWrapper';
import { AutoInvestLoader } from '../../../../shared/components/investors/loaders/autoInvestmentLoader';
import { OTPAuthenticationDialog } from '../../../../shared/components/otpAuthenticationDialog';
import { InvestorService } from '../../investorService';
import { ConfirmAutoInvestDialog } from './confirmAutoInvestDailog';

export const AutoInvesting = () => {
	const investorService = new InvestorService();
	const becomeProService = new BecomeProService();
	const systemSettingsService = new SystemSettingsService();
	const languageService = new LanguageService();

	const staticAI = [
		{
			id: BucketTypes.Balanced,
			title: languageService.isArabic() ? 'الاستثمار الآلي المتوازن' : 'Balanced Auto Investing',
			roiPercent: IS_SA ? "13" : '15'
		},
		{
			id: BucketTypes.Conservative,
			title: languageService.isArabic() ? 'الاستثمار الآلي المتحفظ' : 'Conservative Auto Investing',
			roiPercent: "13"
		}
	];

	const [proStatus, setProStatus] = useState(null);
	const [summary, setSummary] = useState(null);
	const [availableCash, setAvailableCash] = useState(0);
	// eslint-disable-next-line no-unused-vars
	const [buckets, setBuckets] = useState(staticAI);
	const [activatedBucket, setActivatedBucket] = useState({});
	const [selectedBucket, setSelectedBucket] = useState(null);
	const [showOTPDialog, setShowOTPDialog] = useState(false);
	const [isOpenBucketDialog, setIsOpenBucketDialog] = useState(false);
	const queryParams = new URLSearchParams(window.location.search);
	const activateInvest = queryParams.get('activateInvest');
	const confirm = useConfirm();

	const currentYear = new Date().getFullYear();

	const [loading, setLoading] = useState(true);

	const navigate = useNavigate();

	const { t, i18n } = useTranslation();

	useEffect(() => {
		initData();
	}, []);

	const isArabic = () => {
		return languageService.isArabic();
	};

	const isNotInvested = () => {
		return !buckets.find((bucket) => bucket.id === selectedBucket);
	};

	const becomeProRejected = () => {
		if (proStatus?.status === BecomeProStatuses.Rejected) {
			if (DateHelper.dateIsAfter(proStatus?.statusSetDate)) {
				return false;
			}
			return true;
		}
		return false;
	};

	const isDisableBecomeProBtn = () => {
		if (proStatus?.status === BecomeProStatuses.Requested) {
			return true;
		}

		return becomeProRejected();
	};

	const isShowBecomeProBtn = () => {
		if (
			proStatus?.status == null ||
			proStatus?.status === '' ||
			proStatus?.status === undefined
		) {
			return false;
		}

		return proStatus?.status !== BecomeProStatuses.Approved;
	};

	const initData = async () => {
		const [
			shortSummary,
			becomeProStatus,
			summaryData,
			activeAIId,
		] = await Promise.all([
			investorService.getInvestorSummaryShort(),
			becomeProService.getBecomeProStatus(),
			investorService.getInvestorsSummary(),
			investorService.getAutoInvest()
		]).catch((err) => {
			setLoading(false);
		});
		setSummary(summaryData?.data);
		setAvailableCash(shortSummary.data?.availableCash);
		setProStatus(becomeProStatus.data);
		setLoading(false);
		const selectedId = activeAIId.data?.type; //add api call
		setSelectedBucket(selectedId);
		if (activateInvest && !selectedId) {
			const url = new URL(window.location.href);
			url.searchParams.delete("activateInvest");
			window.history.replaceState(null, "", url.toString());
			setActivatedBucket(staticAI[0]);
			setTimeout(() => {
				onCloseBucketDialog(true, staticAI[0], shortSummary.data?.availableCash);
			}, 400);
		}
	};

	const activateBucket = (bucket = null, availCash = availableCash) => {
		let bucketId = bucket?.id || activatedBucket?.id;
		setSelectedBucket(bucketId);
		localStorage.setItem(
			`autoInvestClosingTime`,
			DateHelper.formatDate(new Date(), 'yyyy-MM-dd')
		);
		investorService
			.setInvestingMode(bucketId)
			.then((resp) => {
				setSelectedBucket(bucketId);
				if (availCash <= 0 && getUser()?.isApproved && bucketId) {
					confirm({
						description: t('youDontHaveEnoughMoney'),
						title: "",
						titleProps: { className: "!text-center !capitalize" },
						confirmationButtonProps: {
							className: '!primary-bg !text-white !capitalize !text-sm',
						},
						cancellationButtonProps: {
							style: { border: "1px solid #ccc" },
							className: '!bg-white !text-[#454545] !capitalize !text-sm',
						},
						dialogActionsProps: {
							className: "!justify-center !pb-[16px]"
						},
						dialogProps: {
							style: { maxWidth: "500px", width: "100%" }, // Adjust max width
							className: "!mx-auto", // Center the dialog if needed
						},
						contentProps: { className: "!text-center !pb-1" },
						cancellationText: t('close'),
						confirmationText: t('deposit'),
					})
						.then(() => {
							setTimeout(() => {
								navigate({
									pathname: buildLocalizeRoute(
										`${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.IDeposit}`
									)
								});
							}, 500);
						})
						.catch(() => { });
				}
			})
			.catch((err) => { });
	};

	const onBucketSelect = (bucket) => {
		setActivatedBucket(bucket);
		setTimeout(() => {
			setIsOpenBucketDialog(true);
		});
	};

	const onCloseBucketDialog = (value, bucket = null, availCash = availableCash) => {
		setIsOpenBucketDialog(false);
		if (value) {
			if (systemSettingsService.systemSettings()?.enabledOtp) {
				setShowOTPDialog(true);
			} else {
				activateBucket(bucket, availCash);
			}
		}
	};

	const onOTPClose = (value) => {
		setShowOTPDialog(false);
		if (value) {
			activateBucket();
		}
	};

	const onBecomePro = () => {
		navigate(
			buildLocalizeRoute(
				`${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.BecomeAPro}`
			)
		);
	};

	const investBanner = (text, link, linkText, tooltip = '') => {
		return (
			<Box>
				<TextWrapper
					text={
						<span>
							{t(text)}
							{link ? (
								<a
									className="underline-link mx-1 !text-[16px]"
									href={link}>
									{t(linkText)}
								</a>
							) : null}
						</span>
					}></TextWrapper>
				{tooltip && <CustomTooltip
					tooltipClass="md:!max-w-[300px]"
					iconClassList="!m-0 !text-[13px] !relative !top-[-2px] !left-[2px] !right-[2px]"
					id={tooltip}
					text={t(tooltip)}></CustomTooltip>}
			</Box>
		);
	};

	const bucketPoints = (
		text,
		tooltipText = '',
		id = null,
		secondaryText = ''
	) => {
		return (
			<Box className="flex flex-0 items-start">
				<Box>
					<CheckCircleOutlineIcon color="primary"></CheckCircleOutlineIcon>
				</Box>
				<Box className="mx-2">
					<p className="!text-[16px]">
						{t(text)}
						{tooltipText ? (
							<CustomTooltip
								tooltipClass="md:!max-w-[300px]"
								iconClassList="!m-0 !text-[13px] !relative !top-[-2px] !left-[2px] !right-[2px]"
								id={id}
								text={t(tooltipText)}></CustomTooltip>
						) : null}
						{secondaryText ? t(secondaryText) : null}
					</p>
				</Box>
			</Box>
		);
	};

	// const bucketRiskRatingPoints = (bucket, classList = null) => {
	// 	return (
	// 		<Box className={`grid grid-flow-col gap-16 justify-center ${classList}`}>
	// 			{bucket?.riskRatingEnabledA ? (
	// 				<Box className="auto-invest-risk">A</Box>
	// 			) : null}
	// 			{bucket?.riskRatingEnabledB ? (
	// 				<Box className="auto-invest-risk">B</Box>
	// 			) : null}
	// 			{bucket?.riskRatingEnabledC ? (
	// 				<Box className="auto-invest-risk">C</Box>
	// 			) : null}
	// 		</Box>
	// 	);
	// };

	return (
		<Box className="grid grid-flow-row gap-4">
			{!loading ? (
				<>
					{isNotInvested()
						? investBanner('activateAutoInvestText')
						: investBanner(
							'activatedAutoInvestText',
							'',
							'', 'activatedAutoInvestTooltip'
						)}
					<Box className="flex justify-center items-center my-4">
						<Box className="md:px-4">
							<Box className={`${buckets?.length > 1 ? 'grid md:grid-cols-2 grid-cols-1 gap-6' : 'flex items-center justify-center'}`}>
								{buckets?.length
									? buckets?.map((bucket, index) => {
										return (
											<Section
												key={index}
												classList={`!p-0 !relative ${!isArabic()
													? 'md:!min-h-[590px]'
													: 'md:!min-h-[465px]'
													}`}
												children={
													<Box
														key={index}
														className={`grid grid-flow-row gap-2 md:w-[460px] bucket ${bucket?.id === selectedBucket ? 'active' : ''
															}`}>
														<Box className="flex justify-between">
															<Box className="p-3 flex items-center  bucket-heading border-b-2 border-color-primary w-full">
																<TextWrapper
																	text={bucket?.title}
																	classList="!text-[17px] md:!w-[270px] !font-bold md:!overflow-hidden md:!whitespace-nowrap md:!text-ellipsis"></TextWrapper>
															</Box>
															<Box className="px-1 py-3 flex flex-col items-center bucket-roi min-w-[140px] justify-center">
																<p className="text-[16px] font-bold">
																	<span className="!text-[11px] mx-1">
																		{t('upToPercentage')}
																	</span>
																	{currencyFormatterHelper(
																		bucket?.roiPercent
																	)}
																	%
																</p>

																<p className="!text-[11px]">
																	{t('projectedReturn')}
																</p>
															</Box>
														</Box>
														<Box className="bucket-body md:p-6 p-4 grid grid-flow-row gap-12">
															{bucket?.id === BucketTypes.Balanced ? (
																<Box
																	className={`${!isArabic() ? 'md:mb-[26px]' : ''
																		}`}>
																	{bucketPoints(
																		'autoInvestmentBalancedPortfolioText'
																	)}
																</Box>
															) : (
																bucketPoints(
																	'autoInvestmentConservativePortfolioText'
																)
															)}

															{bucket?.id === BucketTypes.Balanced
																? bucketPoints(
																	'autoInvestmentAutomateInvestText'
																)
																: bucketPoints(
																	'autoInvestmentHigherProjectReturnsConservativeText'
																)}
															{bucket?.id === BucketTypes.Balanced
																? bucketPoints(
																	'autoInvestmentRiskIsMinimizedConservativeText',
																	'autoInvestmentRiskIsMinimizedConservativeTextTooltipText',
																	'autoInvestmentRiskIsMinimizedConservativeTextTooltipText',
																	''
																)
																: bucketPoints(
																	'autoInvestmentRiskIsMinimizedConservativeText1',
																	'',
																	''
																)}
															{/* {bucket?.id === BucketTypes.Balanced
																	? bucketPoints(
																			'autoInvestmentStrategyAimText'
																	  )
																	: bucketPoints(
																			'autoInvestmentAutomateInvestConservativeText'
																	  )} */}
														</Box>
														<Box
															id="activeBtn"
															className={`bucket-footer flex justify-center items-center md:absolute bottom-0 w-full p-4 ${bucket.id === selectedBucket
																? 'primary-bg'
																: 'md:px-16'
																}`}>
															{bucket.id !== selectedBucket ? (
																<Box className="relative w-full">
																	<ButtonWrapper
																		onClick={() => {
																			onBucketSelect(bucket);
																		}}
																		labelClass="!text-[18px] !font-bold"
																		classList="!w-full !border-2 !border-color-primary"
																		variant={'outlined'}
																		label={t('activate')}></ButtonWrapper>
																</Box>
															) : (
																<TextWrapper
																	classList="!sub-heading !font-[500] !text-white"
																	text={t('activated')}></TextWrapper>
															)}
														</Box>
													</Box>
												}></Section>
										);
									})
									: null}
							</Box>
						</Box>
					</Box>
					<Section
						hide={!isShowBecomeProBtn()}
						children={
							<Box className="flex flex-0 md:flex-row flex-col items-center">
								<span className="mb-4 md:mb-0">
									<TextWrapper
										type="span"
										classList="!font-bold"
										text={t('becomePro') + ' - '}></TextWrapper>
									<TextWrapper classList='currency-symbol'
										type="span"
										text={t('becomeProHintText', {
											depositRemained: currencyFormatterHelper(
												summary?.depositRemained
											),
											year: currentYear,
										})}></TextWrapper>
								</span>
								{!isDisableBecomeProBtn() ? (
									<ButtonWrapper
										onClick={() => {
											onBecomePro();
										}}
										label={t('upgrade')}
										classList="md:!w-[200px] md:!mx-2 !w-full"></ButtonWrapper>
								) : (
									<Box>
										<CustomTooltip
											id="pro"
											text={
												becomeProRejected()
													? `${t('becomeProRejectedText')}`
													: proStatus?.status === BecomeProStatuses.Requested
														? `${t('becomeProRequestCompleted')}`
														: ''
											}
											children={
												<ButtonWrapper
													disabled
													label={t('pending')}
													classList="md:!w-[120px] !w-full"></ButtonWrapper>
											}></CustomTooltip>
									</Box>
								)}
							</Box>
						}></Section>
					<Box
						className="relative"
						id="pauseBtn">
						<Section
							hide={!selectedBucket || !buckets?.length}
							children={
								<Box>
									<span>
										<TextWrapper
											type="span"
											classList="!font-bold"
											text={t('pauseInvesting') + ' - '}></TextWrapper>
										<TextWrapper
											type="span"
											text={
												<span className="relative">
													{t('pauseInvestingText')}{' '}
													<a
														className="underline-link !text-[16px]"
														onClick={() => {
															onBucketSelect(null);
														}}>
														{t('here')}
													</a>
												</span>
											}></TextWrapper>
									</span>
								</Box>
							}></Section>
					</Box>
					{isNotInvested() ? (
						<Box>
							<a
								className="underline-link"
								href={`${WEBSITE_URL}${i18n.language}/faq?q=WhatisAutoInvesting`}
								target="_blank"
								rel="noreferrer">
								{t('findOutMoreAboutAutoInesting')}
							</a>
						</Box>
					) : null}
					{!IS_SA ? <Box>
						<p className="caption text-xs font-normal">
							{t('autoInvestmentFooterText')}
						</p>
					</Box> : null}

				</>
			) : (
				<AutoInvestLoader></AutoInvestLoader>
			)}

			{isOpenBucketDialog ? (
				<ConfirmAutoInvestDialog
					state={isOpenBucketDialog}
					bucket={activatedBucket}
					onClose={(e) => {
						onCloseBucketDialog(e);
					}}></ConfirmAutoInvestDialog>
			) : null}

			{showOTPDialog ? (
				<OTPAuthenticationDialog
					type={OTPTypes.Other}
					state={showOTPDialog}
					onClose={(e) => {
						onOTPClose(e);
					}}></OTPAuthenticationDialog>
			) : null}
		</Box>
	);
};
